module.exports = __webpack_public_path__ + "img/厨房电器1.993c1f7d.jpg";